import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";
import { CheckoutToolStepTrackingInfo } from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";
import { getAidenApiKey } from "@utils/configuration/aem";

interface AidenProductImpression {
    aidenProductId: string;
    price: number;
    quantity?: number;
}

const getAidenCheckoutTracker = (): Array<any> => {
    window._aiden = window._aiden || [];
    return window._aiden;
};

const processAidenOrderConfirmation = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>,
): void => {
    if (
        data.payload?.eventData?.name === "checkout" &&
        data.payload?.eventData?.stepName === "order confirmation"
    ) {
        const products: AidenProductImpression[] = (
            data.payload?.eventData?.cart?.items || []
        ).map((item: CartProductTrackingInfo) => {
            return {
                aidenProductId: item.id,
                price: item.unitPrice,
                quantity: item.quantity,
            };
        });

        const tracker = getAidenCheckoutTracker();
        tracker.push({
            event: "Purchase",
            apiKey: getAidenApiKey(),
            orderId: data.payload?.eventData?.cart?.orderId,
            currency: "EUR",
            products,
        });

        return;
    }
};

export { processAidenOrderConfirmation };
